'use client';

import { useTranslations } from 'next-intl';
// import { ReceptionMetrics } from './reception-metrics';
import { ReceptionListing } from './reception-listing';

export function ReceptionPageContent() {
  const t = useTranslations('reception');

  return (
    <div className='space-y-6'>
      <h1 className='text-2xl font-bold tracking-tight'>{t('pageTitle')}</h1>
      {/* <ReceptionMetrics /> */}
      <ReceptionListing />
    </div>
  );
}
